import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";
import KitchenModal from "./KitchenModal";
import Paginations from "../../../components/paginaton/Paginations";

const KitchenList = () => {
  const { branchId } = useParams();
  const [totalPages, setTotalPages] = useState("");
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    cashDeskId: 0,
    saleUnitId: 0,
    categoryId: 0,
    orderType: 0,
    posDeviceId: 0,
    size: 100,
    part: 1,
    invoiceNumber: "",
    orderNumber: 0,
    merchantName: "",
    merchantPhone: "",
    merchantCode: "",
    paymentType: 0,
    orderStatus: 0,
    startDate: methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD"),
    endDate: "",
    total: 0,
    parts: 0,
  });
  const [loading, setLoading] = useState(true);
  const [orderTypes, setOrderTypes] = useState([]);
  const [units, setUnits] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [show, setShow] = useState(null);
  const [cancelableOrderIds, setCancelableOrderIds] = useState({});
  const [countdowns, setCountdowns] = useState({});

  const handleClose = () => setShow(null);
  const handleShow = (id) => {
    setShow(id);
  };

  const getGridData = async () => {
    const kitchenOrdersResp = await apiMethod.getKitchenOrders(
      branchId,
      filterModel.saleUnitId,
      filterModel.orderNumber,
      filterModel.cashDeskId,
      filterModel.posDeviceId,
      filterModel.invoiceNumber,
      filterModel.merchantName,
      filterModel.merchantPhone,
      filterModel.merchantCode,
      filterModel.orderType,
      filterModel.paymentType,
      filterModel.orderStatus,
      filterModel.startDate,
      filterModel.endDate,
      filterModel.part,
      filterModel.size
    );

    if (methods.showApiErrors(kitchenOrdersResp)) {
      setGridData(kitchenOrdersResp.data);
      filterModel.total = kitchenOrdersResp.total;
      filterModel.parts = methods.calcPageParts(
        kitchenOrdersResp.total,
        filterModel.size
      );
      setTotalPages(kitchenOrdersResp.total);
      setFilterModel({ ...filterModel });
      setGridData(kitchenOrdersResp.data);
    }
  };

  const getBaseInfo = async () => {
    const orderTypesResp = await apiMethod.getOrderTypes();
    if (methods.showApiErrors(orderTypesResp))
      setOrderTypes(orderTypesResp.data);

    const resp2 = await apiMethod.getAllUnits(branchId);
    if (methods.showApiErrors(resp2)) setUnits(resp2.data);
  };

  const cancelOrder = async (invoiceId) => {
    setLoading(true);
    var resp = await apiMethod.kitchenCancelOrder(invoiceId);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }

    await getGridData();
    setLoading(false);
  };

  // const orderTypeChanged = async (orderType) => {
  //   setLoading(true);
  //   filterModel.orderType = orderType;
  //   setFilterModel({ ...filterModel });
  //   await getGridData();
  //   setLoading(false);
  // };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      createConnection();
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const changeToCooked = async (id) => {
    try {
      const resp = await apiMethod.changeToCookedOrder(id);

      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
    } catch (error) {
      console.log(error);
    }
  };

  const handleCookButton = (id) => {
    if (cancelableOrderIds[id]) {
      setCancelableOrderIds((prev) => {
        const newState = { ...prev };
        delete newState[id];
        return newState;
      });

      setCountdowns((prev) => {
        const newState = { ...prev };
        delete newState[id];
        return newState;
      });

      if (window.countdownTimers && window.countdownTimers[id]) {
        clearInterval(window.countdownTimers[id]);
        delete window.countdownTimers[id];
      }
    } else {
      setCancelableOrderIds((prev) => ({ ...prev, [id]: true }));
      setCountdowns((prev) => ({ ...prev, [id]: 5 }));

      if (!window.countdownTimers) window.countdownTimers = {};

      window.countdownTimers[id] = setInterval(() => {
        setCountdowns((prev) => {
          const newCountdown = prev[id] - 1;

          if (newCountdown <= 0) {
            clearInterval(window.countdownTimers[id]);
            delete window.countdownTimers[id];

            setCancelableOrderIds((prev) => {
              const newState = { ...prev };
              delete newState[id];
              return newState;
            });
            changeToCooked(id);

            return { ...prev, [id]: 0 };
          }

          return { ...prev, [id]: newCountdown };
        });
      }, 1000);
    }
  };

  const backtoCurrentOrder = async (id) => {
    try {
      setLoading(true);
      const resp = await apiMethod.backToCurrentOrder(id);

      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.cashDeskId = 0;
    filterModel.saleUnitId = 0;
    filterModel.categoryId = 0;
    filterModel.orderType = 0;
    filterModel.posDeviceId = 0;
    filterModel.size = 100;
    filterModel.part = 1;
    filterModel.invoiceNumber = "";
    filterModel.orderNumber = 0;
    filterModel.merchantName = "";
    filterModel.merchantPhone = "";
    filterModel.merchantCode = "";
    filterModel.paymentType = 0;
    filterModel.orderStatus = 0;
    filterModel.startDate = methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD");
    filterModel.endDate = "";
    setFilterModel({ ...filterModel });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const URL =
    process.env.REACT_APP_ROOT_MSG + "/DataHub/?connectionId=" + branchId;
  const createConnection = async () => {
    let conn = new signalR.HubConnectionBuilder()
      .withUrl(URL)
      .withAutomaticReconnect()
      .build();
    await conn
      .start()
      .catch((err) => console.log(err))
      .then(() => {
        conn.invoke("GetConnectionId").then(function (connectionId) {
          console.log("connectionId: " + connectionId);
        });
      });
    conn.on("ReceiveNewOrderPanel", (bid, orderId, status) => {
      if (status === 1) getGridData();
    });
  };

  const selectedItem = gridData.find((item) => item.id === show);

  const renderLists = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block text-start mb-3">
              <Link to={`/sale/${branchId}/#1`} className="link back-link">
                <span>
                  <img src={back} alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link to={`/sale/${branchId}/#1`} className="link back-link">
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                لیست آشپزخانه
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                لیست آشپزخانه
                <a
                  href={`/sale/${branchId}/softwareGuide/#section13`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className="salesearchsection py-4">
                <div className="row gap-4 gap-lg-0">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-2 col-lg-2 col-md-4 col-sm-6">
                        <label htmlFor="searchInput" className="form-label">
                          شماره فیش
                        </label>
                        <div className="hstack">
                          <input
                            id="searchInput"
                            className="form-control"
                            type="text"
                            style={{ direction: "rtl", textAlign: "right" }}
                            value={filterModel.orderNumber}
                            onChange={(e) => {
                              filterModel.orderNumber = e.target.value;
                              setFilterModel({ ...filterModel, part: 1 });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-2 col-lg-2 col-md-4 col-sm-6">
                        <label htmlFor="searchInput" className="form-label">
                           نام
                        </label>
                        <div className="hstack">
                          <input
                            id="searchInput"
                            className="form-control"
                            type="text"
                            style={{ direction: "rtl", textAlign: "right" }}
                            value={filterModel.merchantName}
                            onChange={(e) => {
                              filterModel.merchantName = e.target.value;
                              setFilterModel({ ...filterModel, part: 1 });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-2 col-lg-2 col-md-4 col-sm-6">
                        <label htmlFor="ddlStatuses" className="form-label">
                          بخش های فروش
                        </label>
                        <select
                          id="ddlStatuses"
                          className="form-select"
                          aria-label="menu"
                          value={filterModel.saleUnitId}
                          onChange={(e) => {
                            filterModel.saleUnitId = e.target.value;
                            setFilterModel({ ...filterModel });
                          }}
                        >
                          <option value={0}>همه بخش ها</option>
                          {units.map((item, index) => (
                            <option value={item.id} key={index}>
                              {item.title}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-2 col-lg-2 col-md-4 col-sm-6">
                        <label htmlFor="filters" className="form-label">
                          نوع سفارش
                        </label>
                        <select
                          id="filters"
                          className="form-select"
                          aria-label="menu"
                          value={filterModel.orderType}
                          onChange={(e) => {
                            filterModel.orderType = e.target.value;
                            setFilterModel({ ...filterModel });
                          }}
                        >
                          <option value={0}>همه</option>
                          {orderTypes.map((item, index) => (
                            <option value={item.id} key={index}>
                              {item.title}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-2 col-lg-2 col-md-4 col-sm-6">
                        <label htmlFor="enddate" className="form-label">
                          از تاریخ
                        </label>
                        <DatePicker
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-center"
                          format="YYYY/MM/DD"
                          value={filterModel.startDate}
                          onChange={(value) => {
                            if (value)
                              filterModel.startDate =
                                value.format("YYYY/MM/DD");
                            else filterModel.startDate = "";
                            setFilterModel({ ...filterModel });
                          }}
                          inputClass="form-control"
                          containerStyle={{
                            width: "100%",
                          }}
                        />
                      </div>
                      <div className="col-2 col-lg-2 col-md-4 col-sm-6">
                        <label htmlFor="enddate" className="form-label">
                          تا تاریخ
                        </label>
                        <DatePicker
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-center"
                          format="YYYY/MM/DD"
                          value={filterModel.endDate}
                          onChange={(value) => {
                            if (value)
                              filterModel.endDate = value.format("YYYY/MM/DD");
                            else filterModel.endDate = "";
                            setFilterModel({ ...filterModel });
                          }}
                          inputClass="form-control"
                          containerStyle={{
                            width: "100%",
                          }}
                        />
                      </div>
                      <div className="col-2 col-lg-2 col-md-3 col-sm-4">
                        <div className="pt-4 mt-2">
                          <button
                            type="button"
                            className="btn btn-purple me-1"
                            onClick={searchItem}
                          >
                            <i className="bi bi-search"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-info"
                            onClick={clearSearch}
                          >
                            <i className="bi bi-arrow-clockwise"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="order-cards">
                <div className="row">
                  {gridData.map((item, index) => (
                    <div className="col-md-6 col-xl-4">
                      <div className="card mb-3">
                        <div className="card-body p-2">
                          <div className="d-flex align-items-center justify-content-between mb-4">
                            <div className="fs-14">
                              {methods.toPersianDate(
                                item.createDate,
                                "jYYYY/jMM/jDD"
                              )}
                            </div>
                            <div className="fs-14">
                              <b>{item.saleUnitTitle}</b>
                            </div>
                            <div className="fs-14">
                              <span className="badge sidebar-badge rounded-pill ms-2">
                                {
                                  orderTypes.find(
                                    (orderType) =>
                                      orderType.id === item.orderType
                                  )?.title
                                }
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4 fs-14">
                                {item.merchantName}
                            </div>
                            <div className="col-4 fs-14">
                              شماره فیش : {item.orderNumber}
                            </div>
                            <div className="col-4 fs-14">
                              تعداد: {item.invoiceItems.length}
                            </div>
                          </div>
                          <div className="fs-14 mt-4">
                              {methods.toPersianDate(
                                item.createDate,
                                " ساعت: HH:mm"
                              )}
                            </div>
                          <div className="row mt-4">
                            <div className="col-6">
                              <button
                                className="btn btn-outline-purple w-100"
                                onClick={() => handleShow(item.id)}
                              >
                                جزئیات
                              </button>
                              <KitchenModal
                                id={item.id}
                                show={show === item.id}
                                onHide={handleClose}
                                selectedItem={selectedItem}
                                backtoCurrentOrder={backtoCurrentOrder}
                                cancelOrder={cancelOrder}
                                changeToCooked={changeToCooked}
                              />
                            </div>
                            <div className="col-6">
                              <button
                                type="button"
                                className={`btn ${
                                  cancelableOrderIds[item.id]
                                    ? "btn-danger"
                                    : "btn-outline-purple"
                                } w-100`}
                                onClick={() => handleCookButton(item.id)}
                                disabled={loading}
                              >
                                {cancelableOrderIds[item.id]
                                  ? `بازگشت (${countdowns[item.id]})`
                                  : "تکمیل پخت"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* {filterModel.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )} */}
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={totalPages}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return <>{renderLists()}</>;
};

export default KitchenList;
